import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useFocusTrap } from "../../hook/useFocusTrap";
import { REGISTRATION_KEYBOARD_SCOPE_ATTR } from "../RegistrationLayout/registrationFocusStyles";

const RegistrationLoadRetryModal = ({
  isOpen,
  message,
  onRetry,
  onCancel,
  isRetrying = false,
}) => {
  const { t } = useTranslation();
  const panelRef = useRef(null);

  useFocusTrap({
    isOpen,
    containerRef: panelRef,
    onEscape: isRetrying ? undefined : onCancel,
  });

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      className="booking-error-modal-overlay"
      role="presentation"
      {...REGISTRATION_KEYBOARD_SCOPE_ATTR}
    >
      <div
        ref={panelRef}
        className="booking-error-modal-panel registration-load-retry-modal-panel"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="registration-load-retry-message"
        onClick={(event) => event.stopPropagation()}
      >
        <p
          id="registration-load-retry-message"
          className="booking-error-modal-message"
        >
          {message || t("NUTRITION_COMMON_ERR_TRY_AGAIN")}
        </p>
        <div className="registration-load-retry-modal-actions">
          <button
            type="button"
            className="btn-ghost registration-load-retry-modal-cancel"
            onClick={onCancel}
            disabled={isRetrying}
          >
            {t("CANCEL", { defaultValue: "Cancel" })}
          </button>
          <button
            type="button"
            className="btn-primary booking-error-modal-retry"
            onClick={onRetry}
            disabled={isRetrying}
          >
            {t("TRY_AGAIN")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RegistrationLoadRetryModal;
